import { getAdminTags } from '../api/admin'

export const fetchAdminTags = async (paginate) => {
  const res = await getAdminTags(paginate)
  return {
    type: 'GET_ADMIN_TAGS_SUCCESS',
    data: res.tags
  }
}
